import "./SwipeableModals.scss";
import React, { useState, useEffect } from "react";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  CircularProgress,
} from "@mui/material";

import BlueButton from "../../../components/BlueButton/BlueButton";
import api from "../../../utils/api";
import { message } from "antd";

const SwipeableModals = ({
  open,
  onClose,
  onOpen,
  currentView,
  subscription,
  onSuccess,
  requestId, // Add requestId prop
}) => {
  // State for form data
  const [formData, setFormData] = useState({
    // nameAr: "",
    // nameEn: "",
    // descriptionAr: "",
    // descriptionEn: "",
    price: "",
    type: "", // annually or monthly
    numberOfVisits: "",
    maxmiumDailyVisits: "",
  });

  // State for UI control
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // Reset form when modal closes
  useEffect(() => {
    if (!open) {
      resetForm();
    }
  }, [open]);

  // Fill form data when editing an existing subscription
  useEffect(() => {
    if (subscription && currentView === "editSubscription") {
      setFormData({
        // nameAr: subscription.nameAr || "",
        // nameEn: subscription.nameEn || "",
        // descriptionAr: subscription.descriptionAr || "",
        // descriptionEn: subscription.descriptionEn || "",
        price: subscription.price || "",
        type: subscription.type || "",
        numberOfVisits: subscription.numberOfVisits || "",
        maxmiumDailyVisits: subscription.maxmiumDailyVisits || "",
      });
    }
  }, [subscription, currentView, open]);

  const resetForm = () => {
    setFormData({
      // nameAr: "",
      // nameEn: "",
      // descriptionAr: "",
      // descriptionEn: "",
      price: "",
      type: "",
      numberOfVisits: "",
      maxmiumDailyVisits: "",
    });
    setErrors({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: null,
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    // Required fields validation
    // if (!formData.nameAr || formData.nameAr.length < 2) {
    //   newErrors.nameAr =
    //     "اسم الاشتراك بالعربي مطلوب ويجب أن يكون على الأقل حرفين";
    // }

    // if (!formData.nameEn || formData.nameEn.length < 2) {
    //   newErrors.nameEn =
    //     "اسم الاشتراك بالانجليزية مطلوب ويجب أن يكون على الأقل حرفين";
    // }

    // if (!formData.descriptionAr) {
    //   newErrors.descriptionAr = "وصف الاشتراك بالعربي مطلوب";
    // }

    // if (!formData.descriptionEn) {
    //   newErrors.descriptionEn = "وصف الاشتراك بالانجليزية مطلوب";
    // }

    if (!formData.price || formData.price <= 0) {
      newErrors.price = "سعر الاشتراك مطلوب ويجب أن يكون أكبر من صفر";
    }

    if (!formData.type) {
      newErrors.type = "نوع الاشتراك مطلوب";
    }

    if (!formData.numberOfVisits || formData.numberOfVisits <= 0) {
      newErrors.numberOfVisits = "عدد الزيارات مطلوب ويجب أن يكون أكبر من صفر";
    }

    if (!formData.maxmiumDailyVisits || formData.maxmiumDailyVisits <= 0) {
      newErrors.maxmiumDailyVisits =
        "الحد الاقصي اليومي مطلوب ويجب أن يكون أكبر من صفر";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      let response;

      // Prepare data according to the required format
      const submissionData = {
        status: true,
        type: formData.type,
        maxmiumDailyVisits: parseInt(formData.maxmiumDailyVisits),
        numberOfVisits: parseInt(formData.numberOfVisits),
        price: parseInt(formData.price),
      };

      if (currentView === "createSubscription") {
        // Create new subscription using PATCH with request ID
        if (!requestId) {
          message.error("معرف الطلب غير متوفر");
          return;
        }
        response = await api.patch(
          `/preview-requests/${requestId}`,
          submissionData
        );
        message.success("تم إضافة الاشتراك بنجاح");
      } else if (currentView === "editSubscription" && subscription) {
        // Update existing subscription
        response = await api.patch(
          `/preview-requests/${subscription._id}`,
          submissionData
        );
        message.success("تم تحديث بيانات الاشتراك بنجاح");
      }

      if (response && response.data.status === "success") {
        resetForm();
        onSuccess(); // Refresh subscriptions list
        onClose(); // Close modal
      }
    } catch (error) {
      console.error("Error submitting form:", error);

      // Handle different error types
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        message.error(error.response.data.message);
      } else {
        message.error("حدث خطأ أثناء حفظ البيانات");
      }
    } finally {
      setLoading(false);
    }
  };

  const renderSubscriptionForm = () => (
    <div className="user-modal">
      <p className="user-modal-p">
        {currentView === "createSubscription"
          ? "اضافة اشتراك جديد"
          : "تعديل بيانات الاشتراك"}
      </p>
      <form onSubmit={handleSubmit}>
        {/* اسم الاشتراك بالعربي - COMMENTED OUT */}
        {/* <FormControl sx={{ width: "100%" }} variant="outlined" required>
          <InputLabel
            htmlFor="nameAr"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            اسم الاشتراك بالعربي
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="nameAr"
            name="nameAr"
            type="text"
            value={formData.nameAr}
            onChange={handleInputChange}
            notched
            error={!!errors.nameAr}
          />
          {errors.nameAr && <p className="error-message">{errors.nameAr}</p>}
        </FormControl> */}

        {/* اسم الاشتراك بالانجليزية - COMMENTED OUT */}
        {/* <FormControl sx={{ width: "100%" }} variant="outlined" required>
          <InputLabel
            htmlFor="nameEn"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            اسم الاشتراك بالانجليزية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="nameEn"
            name="nameEn"
            type="text"
            value={formData.nameEn}
            onChange={handleInputChange}
            notched
            error={!!errors.nameEn}
          />
          {errors.nameEn && <p className="error-message">{errors.nameEn}</p>}
        </FormControl> */}

        {/* وصف الاشتراك بالعربي - COMMENTED OUT */}
        {/* <FormControl sx={{ width: "100%" }} variant="outlined" required>
          <InputLabel
            htmlFor="descriptionAr"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            وصف الاشتراك بالعربي
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="descriptionAr"
            name="descriptionAr"
            type="text"
            multiline
            rows={3}
            value={formData.descriptionAr}
            onChange={handleInputChange}
            notched
            error={!!errors.descriptionAr}
          />
          {errors.descriptionAr && (
            <p className="error-message">{errors.descriptionAr}</p>
          )}
        </FormControl> */}

        {/* وصف الاشتراك بالانجليزية - COMMENTED OUT */}
        {/* <FormControl sx={{ width: "100%" }} variant="outlined" required>
          <InputLabel
            htmlFor="descriptionEn"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            وصف الاشتراك بالانجليزية
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="descriptionEn"
            name="descriptionEn"
            type="text"
            multiline
            rows={3}
            value={formData.descriptionEn}
            onChange={handleInputChange}
            notched
            error={!!errors.descriptionEn}
          />
          {errors.descriptionEn && (
            <p className="error-message">{errors.descriptionEn}</p>
          )}
        </FormControl> */}

        {/* سعر الاشتراك */}
        <FormControl sx={{ width: "100%" }} variant="outlined" required>
          <InputLabel
            htmlFor="price"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            سعر الاشتراك
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            placeholder="ريال"
            id="price"
            name="price"
            type="number"
            value={formData.price}
            onChange={handleInputChange}
            notched
            error={!!errors.price}
          />
          {errors.price && <p className="error-message">{errors.price}</p>}
        </FormControl>

        {/* نوع الاشتراك */}
        <FormControl fullWidth required>
          <InputLabel
            htmlFor="type-select"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            نوع الاشتراك
          </InputLabel>
          <Select
            labelId="type-select-label"
            id="type-select"
            displayEmpty={true}
            sx={{ borderRadius: "8px" }}
            value={formData.type}
            onChange={handleInputChange}
            name="type"
            error={!!errors.type}
          >
            <MenuItem value="">
              <em>اختر نوع الاشتراك</em>
            </MenuItem>
            <MenuItem value="monthly">شهري</MenuItem>
            <MenuItem value="annually">سنوي</MenuItem>
          </Select>
          {errors.type && <p className="error-message">{errors.type}</p>}
        </FormControl>

        {/* عدد الزيارات */}
        <FormControl sx={{ width: "100%" }} variant="outlined" required>
          <InputLabel
            htmlFor="numberOfVisits"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            عدد الزيارات
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="numberOfVisits"
            name="numberOfVisits"
            type="number"
            value={formData.numberOfVisits}
            onChange={handleInputChange}
            notched
            error={!!errors.numberOfVisits}
          />
          {errors.numberOfVisits && (
            <p className="error-message">{errors.numberOfVisits}</p>
          )}
        </FormControl>

        {/* الحد الاقصي اليومي */}
        <FormControl sx={{ width: "100%" }} variant="outlined" required>
          <InputLabel
            htmlFor="maxmiumDailyVisits"
            shrink
            sx={{
              background: "white",
              transformOrigin: "right top",
              transform: "translate(14px, -9px) scale(0.75)",
              right: 24,
              left: "auto",
              paddingLeft: "4px",
              paddingRight: "4px",
            }}
          >
            الحد الاقصي اليومي
          </InputLabel>
          <OutlinedInput
            sx={{ borderRadius: "8px" }}
            required
            id="maxmiumDailyVisits"
            name="maxmiumDailyVisits"
            type="number"
            value={formData.maxmiumDailyVisits}
            onChange={handleInputChange}
            notched
            error={!!errors.maxmiumDailyVisits}
          />
          {errors.maxmiumDailyVisits && (
            <p className="error-message">{errors.maxmiumDailyVisits}</p>
          )}
        </FormControl>

        <BlueButton
          text={currentView === "createSubscription" ? "اضافة" : "تحديث"}
          size="medium"
          variant="fill"
          type="submit"
          disabled={loading}
          icon={loading ? <CircularProgress size={20} color="inherit" /> : null}
        />
      </form>
    </div>
  );

  const renderDefaultView = () => <div></div>;

  const views = {
    createSubscription: renderSubscriptionForm,
    editSubscription: renderSubscriptionForm,
  };

  return (
    <SwipeableDrawer
      anchor="left"
      open={open}
      onClose={onClose}
      onOpen={onOpen}
      sx={{ zIndex: "1202" }}
      disableScrollLock
    >
      {(views[currentView] || renderDefaultView)()}
    </SwipeableDrawer>
  );
};

export default SwipeableModals;
